import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IntellioHttpResponse, SupportCenterFolder, SupportCenterFolders, SupportCenterFile } from '@intellio/shared/models';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SupportCenterService extends BaseService {
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getFolders(): Observable<IntellioHttpResponse<SupportCenterFolders>> {
    const url = `/api/supportcenter/folders`;
    return this.get<SupportCenterFolders>(url);
  }

  getFiles(path: string) {
    const url = `/api/supportcenter/files?path=${path}`;
    return this.get<SupportCenterFile>(url);
  }

  getFilesList(path: string) {
    const url = `/api/supportcenter/files/list?path=${path}`;
    return this.get<SupportCenterFolder[]>(url);
  }
}
